import React from 'react'
import { LayoutWrapper } from '@pankod/refine-core'
import clsx from 'clsx'
import dynamic from 'next/dynamic'

import public_styles from '@/css/public.module.css'
import dashboard_styles from '@/dashboard/css/dashboard.module.css'

const LoginPage = () => {
  const DynamicLoginButton = dynamic(() => import('@/components/LoginPage/LoginButton'), {
    ssr: false,
  })

  return (
    <LayoutWrapper>
      <div className={clsx(dashboard_styles.dashboard, public_styles.container)}>
        <div className={dashboard_styles.block}>
          <p>Please, log in to get access to your dashboard</p>
          <DynamicLoginButton />
        </div>
      </div>
    </LayoutWrapper>
  )
}

export default LoginPage
